'use client';
import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { Box, Grid, HStack, Text, VStack } from '@chakra-ui/react';

import StagesContentMobileView from './StagesContentMobileView';
import { stagesAnimation } from 'shared/gsap';
import StageCard from './StageCard';

import { SECTIONS_IDS } from 'constants/global';
import { stagesCardsData } from 'constants/stages';
import { Route } from 'assets/illustrations/stages';

const Stages = () => {
  const cardsContainerRef = useRef(null);
  useGSAP(stagesAnimation(cardsContainerRef));

  return (
    <VStack
      as="section"
      id={SECTIONS_IDS.stages}
      w="full"
      px={{ mobile: '16px', tablet: '20px', laptop: '80px' }}
      gap={{ mobile: '50px', laptop: '85px' }}
      pos="relative"
      overflow="hidden"
    >
      <Text as="h2" textAlign="center" textTransform="uppercase" color="ourWhite">
        Твой маршрут к лидерству
      </Text>

      <Grid
        hideBelow="xt"
        boxSize="full"
        templateColumns="100%"
        templateRows="1fr"
        alignItems="center"
        justifyItems="center"
      >
        <Box gridArea="1 / 1" w="full">
          <Route boxSize="full" />
        </Box>

        <Box
          gridArea="1 / 1"
          w={{ xt: '350px', xxxl: '410px' }}
          h={{ xt: '134px', xxxl: '263px' }}
          mt={{ xt: '25px' }}
          overflow="hidden"
        >
          <HStack ref={cardsContainerRef} gap="16px" align="stretch">
            {stagesCardsData.map(card => (
              <StageCard key={card.cardIndex} {...card} flexShrink={0} />
            ))}
          </HStack>
        </Box>
      </Grid>

      <StagesContentMobileView />
    </VStack>
  );
};

export default Stages;
